import React from "react";
import Card from "@amzn/meridian/card";
import Column from "@amzn/meridian/column";
import Row from "@amzn/meridian/row";
import Text from "@amzn/meridian/text";
import { Icon } from "@amzn/meridian";
import errorFilledTokens from "@amzn/meridian-tokens/base/icon/error-filled";

interface SummaryCardProps {
  totalQuantity: number;
  totalWeight: number;
  weightUnit?: string;
  isOverweight: boolean;
}

const ContainerWeightSummary: React.FC<SummaryCardProps> = ({
  totalQuantity,
  totalWeight,
  weightUnit,
  isOverweight,
}) => (
  <div className={isOverweight ? "summary-card--overweight" : ""}>
    <Card spacingInset="400">
      <Column spacing="300">
        <Row spacing="600">
          <Column spacing="100">
            <Text type="b300" color="secondary">
              Total Quantity
            </Text>
            <Text type="h300" color={isOverweight ? "error" : "success"}>
              {totalQuantity}
            </Text>
          </Column>
          {weightUnit && (
            <Column spacing="100">
              <Text type="b300" color="secondary">
                Total Weight
              </Text>
              <Text type="h300" color={isOverweight ? "error" : "success"}>
                {totalWeight.toFixed(3)} {weightUnit}
              </Text>
            </Column>
          )}
        </Row>
        {isOverweight && (
          <Row spacing="300" alignmentVertical="top">
            <Icon tokens={errorFilledTokens} color="error" />
            <Text type="b200" color="error">
              Exceeded the limit of container. Adjust the numbers of Item to match with container
              capacity
            </Text>
          </Row>
        )}
      </Column>
    </Card>
  </div>
);

export default ContainerWeightSummary;
